import { useState, useEffect } from "react";
import logo from "../../../assets/logozaptodoor.png";
import Bg2video from "../../../assets/IMG_1531.MOV";
import { Menu } from "lucide-react";
import { Link } from "react-router-dom";
import { getData, serverURL } from "../../../Services/Fetchnodeservices";

function Header() {
  const [showScanner, setShowScanner] = useState(false);
  const [webContent, setWebContent] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch active web content
  useEffect(() => {
    fetchActiveWebContent();
  }, []);

  const fetchActiveWebContent = async () => {
    setLoading(true);
    try {
      const response = await getData("Headercontent/fetch_active_webcontent");
      console.log("=== ACTIVE WEB CONTENT RESPONSE ===");
      console.log("Full Response:", response);
      
      if (response && response.status) {
        console.log("✅ Successfully fetched active web content");
        console.log("📊 Data Count:", response.data?.length || 0);
        console.log("📝 Data:", response.data);
        
        if (response.data && response.data.length > 0) {
          setWebContent(response.data[0]);
          console.log("📌 First Active Content Item:", response.data[0]);
          
          response.data.forEach((item, index) => {
            console.log(`Item ${index + 1}:`);
            console.log(`  ID: ${item.id}`);
            console.log(`  Header: ${item.header || 'N/A'}`);
            console.log(`  Title 1: ${item.title1 || 'N/A'}`);
            console.log(`  Subtitle 1: ${item.subtitle1 || 'N/A'}`);
            console.log(`  Title 2: ${item.title2 || 'N/A'}`);
            console.log(`  Subtitle 2: ${item.subtitle2 || 'N/A'}`);
            console.log(`  Video: ${item.video || 'N/A'}`);
            console.log(`  Poster: ${item.poster || 'N/A'}`);
            console.log(`  Status: ${item.status === 1 ? 'Active' : 'Inactive'}`);
            console.log(`  Created At: ${item.created_at || 'N/A'}`);
            console.log(`  Updated At: ${item.updated_at || 'N/A'}`);
            console.log('---');
          });
        } else {
          console.log("⚠️ No active content found");
          setWebContent(null);
        }
      } else {
        console.log("❌ Failed to fetch active web content");
        console.log("Error Message:", response?.message || 'Unknown error');
        setWebContent(null);
      }
    } catch (error) {
      console.error("❌ Error fetching active web content:", error);
      console.error("Error Details:", error.message);
      if (error.response) {
        console.error("Server Response:", error.response.data);
      }
    } finally {
      setLoading(false);
      console.log("=== END OF FETCH ===");
    }
  };

  // Log webContent whenever it changes
  useEffect(() => {
    if (webContent) {
      console.log("🔄 WebContent State Updated:", webContent);
    }
  }, [webContent]);

  // Get video URL from backend or fallback to local video
  const getVideoUrl = () => {
    if (webContent?.video) {
      return `${serverURL}/public/uploadnew/upload/${webContent.video}`;
      
    }
    return Bg2video; // Fallback to local video
  };

  // Get poster URL for fallback image
  const getPosterUrl = () => {
    if (webContent?.poster) {
      return `${serverURL}/public/uploadnew/upload/${webContent.poster}`;
    }
    return null;
  };

  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
      />

      <div
        style={{
          width: "100%",
          height: "100vh",
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Background Video - From Backend or Local */}
        <video
          autoPlay
          loop
          muted
          playsInline
          poster={getPosterUrl()}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            minWidth: "100%",
            minHeight: "100%",
            width: "auto",
            height: "auto",
            objectFit: "cover",
            zIndex: -2,
          }}
        >
          <source src={getVideoUrl()} type="video/mp4" />
          {/* Fallback if video doesn't load */}
          <source src={Bg2video} type="video/mp4" />
        </video>

        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.08)",
            zIndex: -1,
          }}
        />

        {/* Header */}
        <div
          style={{
            width: "100%",
            height: "75px",
            display: "flex",
            alignItems: "center",
            padding: "0 40px",
            color: "#fff",
            zIndex: 1000,
            position: "relative",
          }}
        >
          {/* Logo Left */}
          <img
            src={logo}
            alt="logo"
            style={{
              width: "130px",
              height: "55px",
              objectFit: "contain",
              position: "absolute",
              left: "40px",
            }}
          />

          {/* Center Navigation */}
          <div
            className="desktop-nav"
            style={{
              display: "flex",
              gap: "35px",
              margin: "0 auto",
              alignItems: "center",
              fontSize: "17px",
              fontWeight: "600",
            }}
          >
            <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
              Home
            </Link>

            <Link to="/About" style={{ color: "#fff", textDecoration: "none" }}>
              About
            </Link>

            <Link
              to="/Pressrelease"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Press Release
            </Link>

            <Link
              to="/Services"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Services
            </Link>

            <Link
              to="/Contact"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Contact
            </Link>
          </div>

          {/* Mobile Menu */}
          <button
            className="mobile-menu-btn"
            style={{
              display: "none",
              background: "none",
              border: "none",
              color: "#fff",
              position: "absolute",
              right: "40px",
            }}
          >
            <Menu size={30} />
          </button>
        </div>

        {/* Hero Section - Dynamic Content */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "calc(100vh - 75px)",
            color: "#fff",
            padding: "20px",
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* Dynamic Title - From Backend */}
          <h1
            style={{
              fontSize: "clamp(32px, 6vw, 65px)",
              textAlign: "center",
              marginBottom: "20px",
              textShadow: "0 2px 20px rgba(0,0,0,0.3)",
            }}
          >
            {webContent?.title1 ? (
              // Split the title to keep "Zaptodoor" colored
              webContent.title1.includes('Zaptodoor') ? (
                <>
                  {webContent.title1.split('Zaptodoor')[0]}
                  <span style={{ color: "#6c5ce7" }}>
                    Zaptodoor
                  </span>
                  {webContent.title1.split('Zaptodoor')[1]}
                </>
              ) : (
                webContent.title1
              )
            ) : (
              // Fallback title
              <>
                Welcome To{" "}
                <span style={{ color: "#6c5ce7" }}>
                  Zaptodoor
                </span>{" "}
                Food Delivery
              </>
            )}
          </h1>

          {/* Dynamic Subtitle - From Backend */}
          <p
            style={{
              fontSize: "clamp(16px, 4vw, 20px)",
              textAlign: "center",
              maxWidth: "700px",
              opacity: 0.9,
              marginTop: "10px",
              textShadow: "0 2px 10px rgba(0,0,0,0.3)",
            }}
          >
            {webContent?.subtitle1 || "Fast, reliable, and delicious food delivery at your doorstep"}
          </p>

          {/* Optional: Display Title 2 and Subtitle 2 if available */}
         
          
         

          {/* Show loading state */}
          {loading && (
            <div style={{ marginTop: "20px", color: "#fff" }}>
              Loading content...
            </div>
          )}
        </div>
      </div>

      {/* QR Popup */}
      {showScanner && (
        <>
          <div
            onClick={() => setShowScanner(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,.7)",
              zIndex: 5000,
            }}
          />

          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              zIndex: 6000,
              background: "#fff",
              padding: "25px",
              borderRadius: "20px",
              textAlign: "center",
            }}
          >
            <button
              onClick={() => setShowScanner(false)}
              style={{
                position: "absolute",
                right: "10px",
                top: "10px",
                border: "none",
                background: "none",
                fontSize: "25px",
                cursor: "pointer",
              }}
            >
              ×
            </button>

            <h3
              style={{
                marginBottom: "15px",
                color: "#6c5ce7",
              }}
            >
              Scan QR Code
            </h3>

            <img
              src="https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=https://zaptodoor.com"
              alt="scanner"
              style={{
                width: "250px",
                height: "250px",
              }}
            />
          </div>
        </>
      )}
    </>
  );
}

export default Header;